import { render, staticRenderFns } from "./GenericChartWithTitle.vue?vue&type=template&id=50306401&scoped=true&"
import script from "./GenericChartWithTitle.vue?vue&type=script&lang=js&"
export * from "./GenericChartWithTitle.vue?vue&type=script&lang=js&"
import style0 from "./GenericChartWithTitle.vue?vue&type=style&index=0&id=50306401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50306401",
  null
  
)

/* custom blocks */
import block0 from "./GenericChartWithTitle.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50306401')) {
      api.createRecord('50306401', component.options)
    } else {
      api.reload('50306401', component.options)
    }
    module.hot.accept("./GenericChartWithTitle.vue?vue&type=template&id=50306401&scoped=true&", function () {
      api.rerender('50306401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-analysis/charts/GenericChartWithTitle.vue"
export default component.exports